import { useState } from 'react';
import { Star } from 'lucide-react';
import { cn } from '../lib/utils';

const StarRating = ({ 
  rating = 0, 
  onChange, 
  readonly = false, 
  size = 'md',
  showLabel = true 
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  
  const sizes = {
    sm: 'h-5 w-5',
    md: 'h-7 w-7',
    lg: 'h-8 w-8'
  };
  
  const sizeClass = sizes[size] || sizes.md;
  
  const handleClick = (starValue) => {
    if (readonly) return;
    // If clicking the same star, clear the rating
    if (starValue === rating) {
      onChange?.(0);
    } else {
      onChange?.(starValue);
    }
  };
  
  const handleMouseEnter = (starValue) => {
    if (readonly) return;
    setHoverRating(starValue);
  };
  
  const handleMouseLeave = () => {
    setHoverRating(0);
  };
  
  const displayRating = hoverRating || rating;
  
  return (
    <div className="flex flex-col gap-1">
      {showLabel && (
        <span className="text-xs text-[#666666] font-medium">
          {readonly ? 'Rating' : 'Your Rating'}
        </span>
      )}
      <div 
        className="flex items-center gap-1"
        onMouseLeave={handleMouseLeave}
      >
        {[1, 2, 3, 4, 5].map((starValue) => (
          <button
            key={starValue}
            type="button"
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => handleMouseEnter(starValue)}
            disabled={readonly}
            className={cn(
              "transition-all",
              readonly ? "cursor-default" : "cursor-pointer hover:scale-110"
            )}
            data-testid={`star-${starValue}`}
          >
            <Star
              className={cn(
                sizeClass,
                "transition-colors",
                starValue <= displayRating
                  ? "fill-[#E8C547] text-[#E8C547]"
                  : "fill-transparent text-[#CCCCCC]"
              )}
            />
          </button>
        ))}
        {!readonly && rating === 0 && !hoverRating && (
          <span className="text-xs text-[#999999] ml-2 italic">Tap to rate</span>
        )}
      </div>
    </div>
  );
};

export default StarRating;
